import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";
import CertificateLink from "../../CertificateLink";
import DiamondTypeTag from "../../Popup/DiamondTypeTag";


export const OrderHistoryExpandedDetails = (data) => {
    const expandData = data.data;

    function numberWithCommas(x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <div className="bg-gray-300 confirmExpand p-5 border">
            <div className="bg-white p-5 border">
                <div className="row border-bottom">
                    <div className="col-md-6 d-flex align-items-center flex-wrap">
                        <span className="font-size-h2 font-weight-bolder d-flex align-items-center">
                            #{expandData.conformGoodId}
                            <div
                                className={`label ${ expandData.diamondStatus === "Order Approve" ? "label-primary" 
                                            : expandData.diamondStatus === "Pending" ? "label-warning" 
                                            : expandData.diamondStatus === "Ready For Invoice" ? "label-success" 
                                            : expandData.diamondStatus === "Ready to Ship" ? "label-success"
                                            : expandData.diamondStatus === "Rejected" ? "label-danger"
                                            : expandData.diamondStatus === "QC Rejected" ? "label-danger"
                                            : expandData.diamondStatus === "QC Review" ? "label-warning"
                                            : expandData.diamondStatus === "QC Approved" ? "label-success"
                                            : ""
                                        } label-inline ml-2`}
                                >
                                {expandData.diamondStatus}
                            </div>
                        </span>
                        <br />
                        <div className="text-muted small col-12 p-0">
                            Order Date: {expandData.created_date}
                        </div>
                        <div className="text-muted small col-12 p-0">
                            Order Source: {expandData.order_source}
                        </div>
                    </div>
                    <div className="text-md-right small mb-3 col-md-6">
                        {expandData.coupon_code ? (
                            <div>
                                <span className="font-size-h6 font-weight-bolder" style={{ verticalAlign: 'middle' }}>Coupon Applied:</span>{" "}
                                <span className={`label label-success label-inline mr-2`}>
                                    {expandData.coupon_code}
                                </span>
                            </div>
                        ) : null}
                        {expandData.customerComment && expandData.customerComment !== "null" ? <div> <span className="font-weight-bold">Buy Comment :</span >{expandData.customerComment}</div>: null}
                        {expandData.holdComment && expandData.holdComment !== "null" ? <div> <span className="font-weight-bold">Hold Comment :</span >{expandData.holdComment}</div>: null}
                        {expandData.clientRef && expandData.clientRef !== "null" ? <div> <span className="font-weight-bold">Client Reference :</span >{expandData.clientRef}</div>: null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-left">DIAMOND DETAILS</th>
                                    <th className="text-center"> LOCATION <br /> DELIVERY IN DAYS</th>
                                    <th className="text-center">DISC</th>
                                    {expandData.customerHeaderExchange?<th className="text-center">{expandData.customerHeaderExchange}</th>:""}
                                    <th align="center" className="text-right pr-8">
                                        Our Price(USD) <br />
                                        USD/CT
                                    </th>
                                    {expandData.customerPriceExpandHeader?<th align="center" className="text-right pr-8">
                                        Our Price({expandData.customerPriceExpandHeader}) <br />
                                        {expandData.customerPriceExpandHeader}/CT
                                    </th>:""}
                                    {/* TODO */}
                                    <th align="center" className="text-right pr-8">
                                        Sale Price ({expandData.Currency || "USD"}) <br />
                                        {expandData.Currency || "USD"}/CT
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td className="text-center">
                                    {expandData.diamondType === "PN" || expandData.diamondType === "PL" ? 
                                        <div className=" text-left">
                                            <div className={`mb-1 ${expandData.diamondType === "PN"? "natTab": "labTab"}`}>
                                            <DiamondTypeTag diamondTypeTagColor={expandData.diamondTypeTagColor} diamondTypeTag={expandData.diamondTypeTag}/>
                                                <span className={`text-primary small ml-2`}>
                                                    {expandData.diamondType}-{expandData.stockID}
                                                </span>
                                                <span className={`text-primary text-capitalize small ml-2`}>
                                                By: {expandData.parcelType}
                                                </span>
                                                <span className={`text-primary text-capitalize small ml-2`}>
                                                {expandData.parcelLength?expandData.parcelLength.toFixed(2):"" }-{expandData.parcelWidth?expandData.parcelWidth.toFixed(2):"" } MM
                                                </span>
                                            </div>
                                            <span className="text-dark font-weight-bold d-block">
                                            {expandData.shape}{" "}
                                            {expandData.weight?expandData.weight.toFixed(2):""}Ct.{" "}
                                            {expandData.parcelPieces}Pcs.{" "}
                                            {expandData.color}{" "}
                                            {expandData.clarity}{" "}
                                            </span>
                                        </div>
                                    : 
                                        <div className=" text-left">
                                            <div className={`mb-1 ${expandData.diamondType === "N"? "natTab": "labTab"}`}>
                                            <DiamondTypeTag diamondTypeTagColor={expandData.diamondTypeTagColor} diamondTypeTag={expandData.diamondTypeTag}/>
                                                <span className={`text-primary small mr-2`}>
                                                    {expandData.diamondType === "N" ? "N" : "L"}-{expandData.stockID}
                                                </span>
                                                <CertificateLink Certificate_link={expandData.certificate_link} lab={expandData.lab} certificate={expandData.certificate} className={`mx-2 small`} />
                                            </div>

                                            <span className="text-dark font-weight-bold d-block">
                                                {expandData.shape}{" "}
                                                {expandData.weight}{" "}
                                                {expandData.color}
                                                {expandData.clarity}{" "}
                                                {expandData.cut}{" "}
                                                {expandData.polish}{" "}
                                                {expandData.symmetry}{" "}
                                                {expandData.fluorescence}
                                            </span>
                                        </div>
                                    }
                                        
                                    </td>
                                    <td className="text-center"> {expandData.country} <br /> {expandData.shippingDays ? expandData.shippingDays : "7"} days</td>
                                    <td className={`text-center ${(expandData.discount >= 0) ? 'text-success' : 'text-danger'}`}>
                                        {expandData.diamondType === "PN" || expandData.diamondType === "PL" ? "-" :
                                            <span className={`${(expandData.discount >= 0) ? 'text-success' : 'text-danger'}`}>{Number(expandData.discount).toFixed(2)}%</span>
                                        }
                                    </td>
                                    {expandData.customerHeaderExchange?<td className="text-center"> {expandData.customerExchangeRate}</td>:""}
                                    <td className="text-right">
                                        <span className="font-weight-bold text-primary">  {expandData["ourPriceSymbol"]}{numberWithCommas(parseFloat(expandData["ourPrice"]))}</span><br />
                                        <span className="text-muted">{expandData["ourPriceSymbol"]}/CT {numberWithCommas(parseFloat(expandData["ourRate"]))}</span>
                                    </td>
                                    {expandData.customerPriceExpandHeader?<td className="text-right">
                                        <span className="font-weight-bold text-primary">  {expandData["ourPriceCustomerSymbol"]}{numberWithCommas(parseFloat(expandData["ourPriceCustomer"]))}</span><br />
                                        <span className="text-muted">{expandData["ourPriceCustomerSymbol"]}/CT {numberWithCommas(parseFloat(expandData["ourRateCustomer"]))}</span>
                                    </td>:""}
                                    {/* TODO */}
                                    <td className="text-right">
                                        {numberWithCommas(parseFloat(expandData["MarkUpPrice"])) !== "NaN"  ? <span className="font-weight-bold text-primary">  {expandData?.CurrencySymbol || "$"}{numberWithCommas(parseFloat(expandData["MarkUpPrice"]))}</span> : "-"}<br />
                                        {numberWithCommas(parseFloat(expandData["MarkUpRate"])) !== "NaN" ? <span className="text-muted">{expandData?.Currency || "USD"}/CT {numberWithCommas(parseFloat(expandData["MarkUpRate"]))}</span> : "-"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
